var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 41,
    viewBox: "0 0 80 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5855 18.8828L68.1284 0.660555C67.857 0.227778 67.4998 0 67.1141 0H4.15696C2.47124 0 0.928384 1.59444 0.242669 4.03167C-0.285902 5.92222 0.0855266 8.22278 1.15696 9.49833L10.357 20.4772L1.15696 31.5017C0.0855266 32.7772 -0.285902 35.0778 0.242669 36.9683C0.928384 39.4283 2.47124 41 4.15696 41H67.1284C67.4998 41 67.8712 40.7722 68.1427 40.3394L79.5855 22.1172C79.857 21.6844 79.9998 21.115 79.9998 20.5C79.9998 19.885 79.8427 19.3156 79.5855 18.8828Z",
    fill: "#C9A662"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext1);
export default __webpack_public_path__ + "static/media/next1.5ad16c81a827b70b6f48a518e45177ae.svg";
export { ForwardRef as ReactComponent };